import { apiFetch, safeJson } from './http';

export type SignInResponse = { token: string };
export type OAuthGoogleAuthUrlResponse = { authUrl: string };
export type OAuthGoogleResponse = {
  token: string;
  isNewUser?: boolean;
  user?: {
    publicId: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    isEmailConfirmed?: boolean;
  };
};

export async function signUp(data: {
  firstName: string;
  email: string;
  password: string;
  acceptTerms: true;
  companyName?: string;
}): Promise<'OK'> {
  return apiFetch<'OK'>('/sign-up', { method: 'POST', body: safeJson(data) });
}

export async function signIn(data: { email: string; password: string }): Promise<SignInResponse> {
  return apiFetch<SignInResponse>('/sign-in', { method: 'POST', body: safeJson(data) });
}

export async function verifyEmail(slug: string): Promise<'OK'> {
  return apiFetch<'OK'>(`/verify-email/${encodeURIComponent(slug)}`, { method: 'POST' });
}

export async function googleAuthUrl(): Promise<OAuthGoogleAuthUrlResponse> {
  return apiFetch<OAuthGoogleAuthUrlResponse>('/oauth/google/auth-url', { method: 'GET' });
}

export async function googleExchangeCode(
  code: string,
  opts?: { acceptTerms?: boolean }
): Promise<OAuthGoogleResponse> {
  return apiFetch<OAuthGoogleResponse>('/oauth/google', {
    method: 'POST',
    body: safeJson({
      code,
      ...(opts?.acceptTerms ? { acceptTerms: true } : {}),
    }),
  });
}

export async function forgotPassword(email: string): Promise<'OK'> {
  return apiFetch<'OK'>('/forgot-password', { method: 'POST', body: safeJson({ email }) });
}

export async function verifyForgotPassword(slug: string): Promise<{ publicId: string }> {
  return apiFetch<{ publicId: string }>(
    `/verify-forgot-password/${encodeURIComponent(slug)}`,
    { method: 'POST' }
  );
}

export async function changePassword(data: { slug: string; password: string }): Promise<'OK'> {
  return apiFetch<'OK'>('/change-password', { method: 'POST', body: safeJson(data) });
}

